import React from "react";

export default function MultiMarket() {
  return (
    <div _ngcontent-ng-c2192290883="" className="content">
      <router-outlet _ngcontent-ng-c2192290883="" />
      <app-multimarket _nghost-ng-c1621370743="">
        <div _ngcontent-ng-c1621370743="" className="col-md-12 multimarket p-0">
          <div _ngcontent-ng-c1621370743="" className="mian-wrap">
            <div
              _ngcontent-ng-c1621370743=""
              id="noMultiMarkets"
              className="no-data"
            >
              <h3 _ngcontent-ng-c1621370743="">
                There are currently no followed multi markets.
              </h3>
              <p _ngcontent-ng-c1621370743="">
                Please add some markets from events.
              </p>
            </div>
          </div>
        </div>
        {/**/}
        {/**/}
      </app-multimarket>
      {/**/}
    </div>
  );
}
